// Standard library imports
import React, { useState, useContext } from 'react';
// Internal module imports
import TabsComponent from '../../../components/Tabs/Tabs';
import EICSignalIndex from './EicSignalIndex';
import { AuthContext } from '../../../context/AuthContext';
import EicDataLogs from './EicDataLogs';
import RedisViewer from './RedisViewer';
import CommandLog from './CommandLogs';
// External library imports
import _ from 'lodash';
import { Activations } from './Activations';
import { useQueryParamWithDefault } from '../../../hooks';
import { NumberParam } from 'use-query-params';

const EIC = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);
    const { state } = useContext(AuthContext);
    const eicCode = _.get(state, ['user', 'EICCode']);

    let tabs = [
        {
            name: 'Signal Logs',
            component: (
                <>
                    <EICSignalIndex eicCode={eicCode} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Data Logs',
            component: (
                <>
                    <EicDataLogs eicCode={eicCode} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Activations',
            component: (
                <>
                    <Activations cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default EIC;
